export const adaptIndicacion = (indicacion) => {
    return {
        idIndicacionRI: indicacion?.idIndicacionRI,
        idInsumo: indicacion?.idInsumo,
        nombreInsumo: indicacion?.idInsumoNavigation?.descripcion,
        presentacion: (indicacion?.idInsumoNavigation?.presentacionGenerica + ' ' + indicacion?.idInsumoNavigation?.presentacion + ' ' + indicacion?.idInsumoNavigation?.idUnidadNavigation?.alias),

        cantidadDiaria: indicacion?.cantidadDiaria,
        unidad: indicacion?.idInsumoNavigation?.idUnidadNavigation?.alias,
        eleccion: indicacion?.idInsumoNavigation?.eleccion
    }
}

export const adaptIndicacionesDetalladasArray = (
    indicaciones
) => {
    return structuredClone(indicaciones?.indicacionesRIByIdPantallaRI)
        ?.map(indicacion => adaptIndicacion(indicacion));
}